module.exports = __webpack_public_path__ + "img/gp_lc.4bf3425.png";